module.exports = __webpack_public_path__ + "img/menu.ba8c1e32.svg";